(function () {
  var ticking = false;

  function getProgressBars() {
    var bars = Array.prototype.slice.call(document.querySelectorAll('.ms-reading-progress'));
    var idBar = document.getElementById('ms-rp');

    if (idBar && bars.indexOf(idBar) === -1) {
      bars.push(idBar);
    }

    return bars;
  }

  function scrollableDistance() {
    var scrollingElement = document.scrollingElement || document.documentElement;
    var bodyHeight = document.body ? document.body.scrollHeight : 0;
    var scrollHeight = Math.max(scrollingElement.scrollHeight, bodyHeight);

    return Math.max(0, scrollHeight - scrollingElement.clientHeight);
  }

  function scrollTopNow() {
    var scrollingElement = document.scrollingElement || document.documentElement;

    return Math.max(
      window.scrollY || 0,
      window.pageYOffset || 0,
      scrollingElement.scrollTop || 0,
      document.documentElement.scrollTop || 0,
      document.body ? document.body.scrollTop || 0 : 0
    );
  }

  function updateReadingProgress() {
    var bars = getProgressBars();
    if (!bars.length) return;

    var max = scrollableDistance();
    var scrollTop = scrollTopNow();
    var percent = max > 0 ? Math.min(100, (scrollTop / max) * 100) : 0;
    var roundedPercent = String(Math.round(percent));

    bars.forEach(function (bar) {
      bar.style.setProperty('width', percent + '%', 'important');
      bar.style.setProperty('display', 'block', 'important');
      bar.style.setProperty('background-color', 'var(--ms-primary, #0077a8)', 'important');
      bar.setAttribute('aria-valuenow', roundedPercent);
    });
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(function () {
      updateReadingProgress();
      ticking = false;
    });
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  document.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('load', requestUpdate);

  window.msReadingProgress = {
    update: updateReadingProgress,
    debug: function () {
      var scrollingElement = document.scrollingElement || document.documentElement;
      var bars = getProgressBars();

      return {
        bars: bars.length,
        scrollY: window.scrollY || 0,
        pageYOffset: window.pageYOffset || 0,
        scrollingElementScrollTop: scrollingElement.scrollTop || 0,
        documentElementScrollTop: document.documentElement.scrollTop || 0,
        bodyScrollTop: document.body ? document.body.scrollTop || 0 : 0,
        scrollableDistance: scrollableDistance(),
        currentBarWidth: bars[0] ? bars[0].style.width : null,
        scriptLoaded: true
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestUpdate);
  } else {
    requestUpdate();
  }
})();
